/**
 * Bộ lọc danh sách thẻ — đồng bộ server (không dùng onFilter của Ant Table).
 */
export type ScheduleMonthBucket = 'completed' | 'pending' | 'no_schedule';

export interface CreditCardServerFilters {
  search: string;
  bankIds: number[];
  cardTypeIds: number[];
  customerId: number | null;
  statuses: string[];
  newStatuses: string[];
  isActive: boolean | null;
  partnerIds: number[];
  scheduleMonthBuckets: ScheduleMonthBucket[];
  cyclePaymentDays: number[];
  expiryDateRange: [string, string] | null;
  creditLimitRange: [number, number] | null;
  defaultFeeRateRange: [number, number] | null;
  creditLimitContains: string;
  defaultFeeRateContains: string;
  expiryDateContains: string;
}

export const defaultCreditCardServerFilters = (): CreditCardServerFilters => ({
  search: '',
  bankIds: [],
  cardTypeIds: [],
  customerId: null,
  statuses: [],
  newStatuses: [],
  isActive: null,
  partnerIds: [],
  scheduleMonthBuckets: [],
  cyclePaymentDays: [],
  expiryDateRange: null,
  creditLimitRange: null,
  defaultFeeRateRange: null,
  creditLimitContains: '',
  defaultFeeRateContains: '',
  expiryDateContains: '',
});
